export { default } from "./DebouncedFrame";
